import * as React from 'react';
import { Flex, FlexDirection } from 'src/components/Flex/Flex';
import { FlexPosition, ResponsiveSize, Color, CORNER_RATIO } from 'src/components/Globals/Globals';
import styled from 'styled-components';
import logo from './logo.png';
import { AutocompleteInput } from '../AutocompleteInput/AutocompleteInput';
import { Link } from 'react-router-dom';

// Placeholder values for the autocomplete function. Change to props in the future?
const autocompleteOptions = [
  { id: '1', label: 'Solution 1' },
  { id: '2', label: 'Solution 2' },
  { id: '3', label: 'Solution 3' }
];

// Wrapper for the whole top part of the header wrapper (only excluding the splitter)
const StyledHeader = styled(Flex)`
  background: ${Color.lighterBlue};
`;

// Header constants
const HEADER_HEIGHT = '120px';
const HEADER_HEIGHT_MOBILE = '72px';

const LOGO_HEIGHT = '4em';
const LOGO_PADDING = '10px';
const LOGO_WRAPPER_WIDTH = '175px';
const LOGO_WRAPPER_WIDTH_MOBILE = '95px';

const LOGO_HEIGHT_MOBILE = '2em';

const TITLE_HEIGHT = '62px';

const Logo = styled.img`
  background: ${Color.white};
  padding: ${LOGO_PADDING};
  height: ${LOGO_HEIGHT};
  @media (max-width: ${ResponsiveSize.tablet}) {
    height: ${LOGO_HEIGHT_MOBILE};
  }
`;

// Wrapper for the logo on the top left.
const LogoWrapper = styled.div`
  flex-grow: 0;
  flex-shrink: 1;
  width: ${LOGO_WRAPPER_WIDTH};
  align-self: flex-start;
  &:before {
    content: '';
    top: 0px;
    left: 98px;
    position: absolute;
    border-bottom: calc(${LOGO_HEIGHT} + ${LOGO_PADDING} * 2) solid ${Color.lighterBlue};
    border-left: calc((${LOGO_HEIGHT} + ${LOGO_PADDING} * 2) * ${CORNER_RATIO}) solid ${Color.white};
    @media (max-width: ${ResponsiveSize.tablet}) {
      left: 59px;
      border-bottom: calc(${LOGO_HEIGHT_MOBILE} + 20px) solid ${Color.lighterBlue};
      border-left: calc((${LOGO_HEIGHT_MOBILE} + 20px) * ${CORNER_RATIO}) solid ${Color.white};
    }
    width: 0;
    z-index: 0;
  }

  @media (max-width: ${ResponsiveSize.tablet}) {
    height: ${LOGO_HEIGHT_MOBILE};
    width: ${LOGO_WRAPPER_WIDTH_MOBILE};
  }
`;

// Wrapper for the search bar in the middle.
const SearchWrapper = styled(Flex)`
  align-self: flex-end;
  @media (max-width: ${ResponsiveSize.tablet}) {
    align-self: center;
  }
  z-index: 1;
`;

// Wrapper for the header on top right
const TitleWrapper = styled(Flex)`
  background: ${Color.middleBlue};
  height: ${TITLE_HEIGHT};
  color: ${Color.white};
  width: 100%;
  flex: 1;
  align-self: flex-start;

  @media (max-width: ${ResponsiveSize.tablet}) {
    display: none;
  }

  &:before {
    content: '';
    top: 0px;
    right: calc((100% - ${LOGO_WRAPPER_WIDTH}) * 0.4);
    position: absolute;
    border-bottom: ${TITLE_HEIGHT} solid ${Color.lighterBlue};
    border-right: calc(${TITLE_HEIGHT} * ${CORNER_RATIO}) solid ${Color.middleBlue};
    width: 0;
  }
`;

// Page header text on the top right side of the page.
// If the text changes length, the orange line has to be made wider.
const PageTitle = styled.header`
  text-align: center;
  font-size: large;
  font-weight: bolder;

  &:before {
    content: '';
    top: 61.5px;
    position: absolute;
    width: 230px;
    height: 5px;
    background: ${Color.orange};
  }
`;

// "Splitter" on the bottom of the header section.
const HeaderSplitter = styled(Flex)`
  background: ${Color.lighterBlue};
  &:before {
    content: '';
    top: 0px;
    left: calc(100% - 2em);
    position: relative;
    border-bottom: calc((1 / 3) * ${HEADER_HEIGHT}) solid ${Color.white};
    border-left: calc((1 / 3) * ${HEADER_HEIGHT} * ${CORNER_RATIO}) solid ${Color.lighterBlue};
    width: 0;
  }

  @media (max-width: ${ResponsiveSize.tablet}) {
    display: none;
  }
`;

// Min and max heigth instead of just height, because, for some reason, Firefox does not support height in this case.
const HeaderWrapper = styled(Flex)`
  flex-shrink: 0;
  flex-grow: 0;
  min-height: ${HEADER_HEIGHT};
  max-height: ${HEADER_HEIGHT};

  @media (max-width: ${ResponsiveSize.tablet}) {
    min-height: ${HEADER_HEIGHT_MOBILE};
    max-height: ${HEADER_HEIGHT_MOBILE};
  }
`;

export class Header extends React.Component {
  public render() {
    return (
      <HeaderWrapper direction={FlexDirection.column}>
        <StyledHeader
          direction={FlexDirection.row}
          alignHorizontal={FlexPosition.center}
          alignVertical={FlexPosition.center}
          flexSize={2}
        >
          <LogoWrapper>
            <Link to="/">
              <Logo src={logo} />
            </Link>
          </LogoWrapper>
          <SearchWrapper flexSize={1.5}>
            <AutocompleteInput options={autocompleteOptions} />
          </SearchWrapper>
          <TitleWrapper alignHorizontal={FlexPosition.center} alignVertical={FlexPosition.center}>
            <PageTitle>Services offering catalogue</PageTitle>
          </TitleWrapper>
        </StyledHeader>
        <Flex flexSize={1} style={{ flexGrow: 0 }}>
          <HeaderSplitter />
          <Flex />
        </Flex>
      </HeaderWrapper>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Header/Header.tsx